<template>
  <div class="case-info" v-if="status">
    <div class="content">
      <div class="no">
        案号：{{ info.caseNo }} <img @click="$emit('handle', { type: 3, event: -1 })" class="click" src="../assets/icon_close.png" alt="">
      </div>
      <div class="info">
        <div>案由：{{ info.arbitrationReason }}</div>
        <div>金额：{{ info.controversyAmount }}</div>
        <div>仲裁员: {{ info.member[2]  }}</div>
        <div>秘书: {{ info.member[3] }}</div>
        <div class="d">申请人: {{ info.member[0] }}</div>
        <div class="d">被申请人: {{ info.member[1] }}</div>
        <div class="d">申请代理人: {{ info.member[5] }}</div>
        <div class="d">被申请人代理人: {{ info.member[6] }}</div>
        <div class="d">证人: {{ info.member[4] }}</div>
        <div>开庭时间：{{ info.arrangeTime }}</div>
        <div>开庭状态：{{ info.state === 0 ? '待开庭' : info.state === 1 ? '开庭中' : '已开庭' }}</div>
      </div>
      <div v-if="infoType <= 0" class="file">
        <div  v-for="(item, idx) in fileList" :key="idx" @click="_openFileList(idx)">
          <div class="click box">
            <div class="icon">
              <img src="../assets/icon_case_file.png">
            </div>
            <div class="text ellipsis">
              <span>{{item.title}}</span>
            </div>
            <span class="num">{{ item.arr.length }}</span>
          </div>
        </div>
      </div>
      <div v-if="infoType === 1 || infoType === 2" class="code">
        <div>
          <img v-if="codeStatus === 0" :src="code" alt="">
          <img v-if="codeStatus === 1" class="s" src="../assets/success.png" alt="">
          <div v-if="codeStatus < 0" class="overdue">
            <p>{{ codeStatus === -1 ? '二维码已过期': '操作失败' }}</p>
            <button class="click" @click="_getWxCode">点我刷新</button>
          </div>
        </div>
        <p v-if="infoType === 1"><span v-if="codeStatus !== 1">用微信扫一扫，进行人脸识别</span> <span v-if="codeStatus === 1">您已在移动设备通过人脸识别</span></p>
        <p v-if="infoType === 2"><span v-if="codeStatus !== 1">用微信扫一扫，进行签名</span> <span v-if="codeStatus === 1">您已在移动设备签名成功</span></p>
      </div>
      <div class="btn">
        <div v-if="infoType === 0"><button class="click" v-if="info.state === 1" @click="$emit('handle', { type: 3, event: 1 })">进入开庭</button><button class="click" @click="$emit('handle', { type: 3, event: 2, data : { memberType: cmember.memberType } })">上传证据</button></div>
        <div v-if="codeStatus === 1 && infoType === 1"><button class="click" @click="$emit('handle', { type: 3, event: 1 })">进入开庭</button></div>
      </div>
    </div>
    <a-drawer
      v-if="fileList.length > 0"
      :title="fileList[fileIdx].title"
      placement="right"
      :closable="false"
      width="400"
      :visible="fileVisible"
      @close="_openFileList"
    >
      <div class="file-item click" v-for="(item, idx) in fileList[fileIdx].arr" :key="idx">
        <p>  <img src="../assets/icon_case_fujian.png" alt=""> <span>{{ idx + 1  }}.</span>文件名称： {{ item.fileName }}</p>
        <p>描述：{{ item.description }}</p>
        <p>文件格式：{{ item.fileType }} <a :href="item.filePath" :download="item.fileName + '.' + item.fileType" target="_blank" >下载</a></p>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { caseInfo, getMiniCode, meCourtRecord, getMiniCodeProgress } from '@/service/getData'
export default {
  props: {
    infoType: {
      default: 0
    },
    status: {
      default: false
    },
    id: {
      default: 0
    }
  },
  data () {
    return {
      fileIdx: 0,
      fileList: [],
      recordId: 0,
      code: '',
      uid: '',
      fileVisible: false,
      info: {
        member: []
      },
      cmember: {},
      iv: null,
      codeStatus: 0
    }
  },
  computed: mapState(['userInfo']),
  methods: {

    _openFileList (idx) {
      if (idx > -1) {
        if (this.fileList[idx].arr.length > 0) {
          this.fileIdx = idx
          this.fileVisible = true
        }
      } else {
        this.fileVisible = false
      }
    },

    /**
     * 获取微信二维码进度
     */
    getWxCodeProgress () {
      var _this = this
      var time = new Date().getTime() / 1000
      var func = async () => {
        var res = await getMiniCodeProgress(_this.uid)
        if (res.code === 1) {
          if (res.data === 1) {
            _this.codeStatus = 1
            this.$emit('handle', { type: 3, event: 3 })
            if (this.iv !== null) {
              clearInterval(this.iv)
            }
          } else if (res.data === 0) {
            _this.codeStatus = -2
            if (this.iv !== null) {
              clearInterval(this.iv)
            }
          }
        }
        if (new Date().getTime() / 1000 - time > 300) {
          _this.codeStatus = -1
          if (this.iv !== null) {
            clearInterval(this.iv)
          }
        }
      }
      func()
      this.iv = setInterval(func, 3000)
    },

    /**
     * 获取小程序二维码
     */
    async _getWxCode () {
      // 0 案件信息 1 人脸识别 2 签名
      if (this.infoType !== 0) {
        this.codeStatus = 0
        this.code = ''
        var page = null
        var data = null
        var res = null
        //  签名
        if (this.infoType === 2) {
          page = 'pages/sign/sign'
          res = await meCourtRecord(this.id)
          if (res.code === 1) {
            data = `id=${res.data.id}`
            this.recordId = res.data.id
          } else {
            this.$message.error('没有可签名笔录')
            this.$emit('handle', { type: 3, event: -1 })
          }
        //  人脸识别
        } else {
          page = 'pages/face/face'
          data = `memberId=${this.cmember.id}`
        }
        res = await getMiniCode({ page: page, scene: data })
        if (res.code === 1) {
          this.code = res.data.image
          this.uid = res.data.uid
          this.getWxCodeProgress()
          this.codeBtnText = '等待扫码'
        } else {
          this.$message.error(res.msg)
          this.$emit('handle', { type: 3, event: -1 })
        }
      }
    },

    /**
     * 案件信息
     */
    async getInfo () {
      var res = await caseInfo(this.id)
      if (res.code === 1) {
        this.info = this.member(res.data)
        if (this.infoType <= 0) {
          this.fileList = [
            {
              title: '仲裁申请书',
              arr: []
            },
            {
              title: '申请人身份材料',
              arr: []
            },
            {
              title: '被申请人身份材料',
              arr: []
            },
            {
              title: '申请人证据材料',
              arr: []
            },
            {
              title: '被申请人证据材料',
              arr: []
            }
          ]
          var arr = this.info.meetingFileDtoList
          for (var i = 0; i < arr.length; i++) {
            arr[i].fileType = this.getFileType(arr[i].filePath)
            this.fileList[arr[i].type].arr.push(arr[i])
          }
        }
      }
      this._getWxCode()
    },

    /**
     * 获取文件类型
     */
    getFileType (str) {
      if (str.indexOf('.jpg') !== -1) {
        return 'JPG'
      }
      if (str.indexOf('.jpeg') !== -1) {
        return 'JPEG'
      }
      if (str.indexOf('.png') !== -1) {
        return 'PNG'
      }
      if (str.indexOf('.pdf') !== -1) {
        return 'PDF'
      }
    },

    /**
     * 成员处理
     */
    member (data) {
      var list = data.meetingMemberDtoList
      var arr = {}
      for (var i = 0; i < list.length; i++) {
        if (arr[list[i].memberType]) {
          arr[list[i].memberType] += ',' + list[i].name
        } else {
          arr[list[i].memberType] = list[i].name
        }
        if (list[i].idCard === this.userInfo.idCard) {
          this.cmember = list[i]
        }
      }
      data.member = arr
      return data
    }
  },

  destroyed () {
    if (this.iv !== null) {
      clearInterval(this.iv)
    }
  },

  watch: {
    status (newStatus, oldStatus) {
      if (newStatus) {
        this.getInfo()
      } else {
        this.code = ''
        this.codeBtnText = '等待扫码'
        this.codeStatus = 1
        if (this.iv !== null) {
          clearInterval(this.iv)
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import "../style/mixin";
.file-item {
  margin-top: 0.2rem;
  p {
    position: relative;
    padding-left: 0.3rem;
    line-height: 0.3rem;
    img {
      position: absolute;
      left: 0;
      width: 0.2rem;
      height: 0.2rem;
      top: 0.08rem;
    }
    a {
      position: absolute;
      right: 0;
      color: #5887FF
    }
  }
}
.case-info {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.3);
  .content {
    @include center;
    background-color: #fff;
    width: 8rem;
    border-radius: 0.042rem;
    overflow: hidden;
    .file {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      padding-left: 0.2rem;
      margin-bottom: 0.2rem;
      &>div {
        width: 20%;
      }
      .box {
        background-color: #fff;
        margin-right: 0.2rem;
        border-radius: 0.1rem;
        border: 2px solid #5887FF;
        text-align: center;
        padding: 0.2rem 0;
        position: relative;
        .num {
          position: absolute;
          right: 0.1rem;
          top: 0.1rem;
          color: #FFFFFF;
          background-color: #5887FF;
          font-size: 0.05rem;
          font-family: PingFang SC;
          font-weight: 500;
          border-radius: 100%;
          width: 0.2rem;
          height: 0.2rem;
          line-height: 0.2rem;
        }
        .icon img {
          width: 0.5rem;
          height: 0.5rem;
        }
        .text {
          font-size: 0.15rem;
          font-family: PingFang SC;
          font-weight: 500;
          color: #333333;
          margin-top: 0.2rem;
        }
      }
    }
    .code {
      text-align: center;
      margin-top: 0.208rem;
      &>div {
        width: 1.442rem;
        height: 1.442rem;
        margin: 0 auto;
        position: relative;
        .overdue {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          line-height: 1;
          font-size: 0.233rem;
          font-family: PingFang SC;
          font-weight: bold;
          background-color: #f5f5f5;
          p {
            margin-top: 0.3rem;
          }
          button {
            background-color: transparent;
            color: #576b95;
          }
        }
      }
      .s {
        width: 60%;
        height: 60%;
      }
      img {
        width: 100%;
        height: 100%;
      }
      p {
        font-size: 0.15rem;
        font-family: PingFang SC;
        font-weight: bold;
        padding-top: 0.183rem;
        padding-bottom: 0.192rem;
      }
    }
    .btn {
      text-align: center;
      padding-bottom: 0.275rem;
      button {
        background-color: #267CD0;
        color: #fff;
        padding: 0.025rem 0.1rem;
        border-radius: 0.13rem;
        margin: 0 0.1rem;
        font-size: 0.133rem;
        font-family: PingFang SC;
        font-weight: 500;
        color:rgba(255,255,255,1);
      }
    }
    .info {
      padding: 0.2rem 0.5rem;
      display: flex;
      flex-wrap: wrap;
      &>div {
        font-size: 0.133rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: #272727;
        padding-top: 0.165rem;
        width: 50%;
        &.d {
          width: 100%;
        }
      }
    }
    .no {
      height: 0.442rem;
      line-height: 0.442rem;
      font-size: 0.15rem;
      font-family:PingFang SC;
      font-weight:bold;
      text-align: center;
      background-color: #CDD8E7;
      position: relative;
      img {
        position: absolute;
        z-index: 2;
        right: 0.133rem;
        top: 0.125rem;
        @include wh(0.2rem, 0.2rem)
      }
    }
  }
}
</style>
